import axios, { AxiosInstance } from 'axios';
import { serialize } from '@kwixeo/interface-vue'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  paramsSerializer: serialize
});

export default axiosInstance
